import { TemplateTranslationDict, fallbackCopy } from '../helpers';
import { Template } from '../models';
import { stringToProsemirror } from '../tip-tap';
import { answerByCategoryTitleOnlyLayout } from './answer-by-category-templates';
import {
  dragAndDropTitleOnlyLayout,
  dragAndDropSingleDropZoneLayout,
  dragAndDropQuadDropZoneWithTextLayout,
  dragAndDropQuadDropZoneWithImageLayout,
} from './drag-and-drop-templates';
import { fillInTheBlanksTitleOnlyLayout } from './fill-in-the-blanks-templates';
import {
  openQuestionEmptyLayout,
  openQuestionImageOnlyLayout,
  openQuestionQuestionLeftWithImageLayout,
  openQuestionQuestionRightWithImageLayout,
  openQuestionTitleOnlyLayout,
} from './open-question-templates';
import { pollTitleOnlyLayout } from './poll-templates';
import { quizTitleOnlyLayout } from './quiz-templates';
import {
  slideTitleWithBodytextLayout,
  slideImageLeftLayout,
  slideImageRightLayout,
  slideBlankLayout,
  slideCoverLayout,
  slideImageTopLayout,
  slideDoubleColumnImageLayout,
  slideDoubleColumnTextLayout,
  slideFullSizeVideoLayout,
} from './slide-templates';
import { sortingQuestionTitleOnlyLayout } from './sorting-question-templates';
import { LessonUpStyleSets } from './template-style-set';
import { wordCloudTitleOnlyLayout } from './word-cloud-templates';

export const createLessonUpTemplate = (translations: TemplateTranslationDict = fallbackCopy): Template => {
  return {
    id: 'lesson-up',
    name: 'LessonUp',
    styleSets: LessonUpStyleSets,
    layouts: {
      slidePinLayouts: [
        slideBlankLayout({}),
        slideCoverLayout({}),
        slideTitleWithBodytextLayout({
          title: {
            content: stringToProsemirror(translations['slide.title'], {
              bold: true,
            }),
          },
          body: { content: stringToProsemirror(translations['slide.body']) },
        }),
        slideImageLeftLayout({
          title: {
            content: stringToProsemirror(translations['slide.title'], {
              bold: true,
            }),
          },
          body: { content: stringToProsemirror(translations['slide.body']) },
        }),
        slideImageRightLayout({
          title: {
            content: stringToProsemirror(translations['slide.title'], {
              bold: true,
            }),
          },
          body: { content: stringToProsemirror(translations['slide.body']) },
        }),
        slideDoubleColumnImageLayout({
          textOne: {
            content: stringToProsemirror(translations['image.caption']),
          },
          textTwo: {
            content: stringToProsemirror(translations['image.caption']),
          },
        }),
        slideDoubleColumnTextLayout({
          title: {
            content: stringToProsemirror(translations['slide.title'], {
              bold: true,
            }),
          },
          subTitleOne: {
            content: stringToProsemirror(translations['column.title'], {
              bold: true,
            }),
          },
          textOne: {
            content: stringToProsemirror(translations['column.body']),
          },
          subTitleTwo: {
            content: stringToProsemirror(translations['column.title'], {
              bold: true,
            }),
          },
          textTwo: {
            content: stringToProsemirror(translations['column.body']),
          },
        }),
        slideImageTopLayout({
          title: {
            content: stringToProsemirror(translations['slide.title'], {
              bold: true,
            }),
          },
        }),
        slideFullSizeVideoLayout({}),
      ],
      // TODO: recreate the 5 existing layouts
      quizPinLayouts: [
        quizTitleOnlyLayout({
          question: translations['quiz.title'],
        }),
      ],
      openQuestionLayouts: [
        openQuestionTitleOnlyLayout({
          question: translations['openQuestion.title'],
        }),
        openQuestionQuestionLeftWithImageLayout({
          question: translations['openQuestion.title'],
        }),
        openQuestionQuestionRightWithImageLayout({
          question: translations['openQuestion.title'],
        }),
        openQuestionImageOnlyLayout(),
        openQuestionEmptyLayout(),
      ],
      pollPinLayouts: [
        pollTitleOnlyLayout({
          question: translations['poll.title'],
        }),
      ],
      wordCloudLayouts: [
        wordCloudTitleOnlyLayout({
          question: translations['wordCloud.title'],
        }),
      ],
      fillInTheBlanksLayouts: [
        fillInTheBlanksTitleOnlyLayout({
          question: translations['fillInTheBlanks.title'],
          htmlContent: translations['fillInTheBlanks.body'],
        }),
      ],
      answerByCategoryLayouts: [
        answerByCategoryTitleOnlyLayout({
          question: translations['answerByCategory.title'],
          categoryOne: translations['answerByCategory.category1'],
          categoryTwo: translations['answerByCategory.category2'],
        }),
      ],
      sortingQuestionLayouts: [
        sortingQuestionTitleOnlyLayout({
          question: translations['sortingQuestion.title'],
        }),
      ],
      dragAndDropLayouts: [
        dragAndDropTitleOnlyLayout({
          question: translations['dragAndDrop.title'],
        }),
        dragAndDropSingleDropZoneLayout({
          question: translations['dragAndDrop.title'],
        }),
        dragAndDropQuadDropZoneWithTextLayout({
          question: translations['dragAndDrop.title'],
        }),
        dragAndDropQuadDropZoneWithImageLayout({
          question: translations['dragAndDrop.title'],
        }),
      ],
    },
  };
};
